import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/ViewTheme.vue')
  },
  {
    path: '/tema/:route',
    name: 'Theme',
    component: () => import('../views/ViewTheme.vue')
  },
  {
    path: '/kammare/:routes',
    name: 'Chambers',
    component: () => import('../views/ViewChambers.vue')
  },
  {
    path: '/om',
    name: 'About',
    component: () => import('../views/ViewAbout.vue')
  },
  {
    path: '/skapa/:p1?/:p2?',
    name: 'Create',
    component: () => import(/* webpackChunkName: "about" */ '../views/Redirect.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
